module.exports = __webpack_public_path__ + "static/img/-s-icon geren (2).8e0a53f9.svg";